import React from 'react';

const Restricted = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <div className="text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-red-600 mb-2">
          Access Denied
        </h1>
        <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300">
          You do not have permission to view this page.
        </p>
      </div>
    </div>
  );
};

export default Restricted;
